import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* Elagili packaging tap fix — works on both cart page and cart drawer, including iPhone/iPad. */
if (!window.__elagiliMobilePackagingFixLoaded) {
  window.__elagiliMobilePackagingFixLoaded = true;

  const selectPackagingRow = (event) => {
    const label = event.target.closest?.('.elagili-packaging-option');
    if (!label) return;
    if (event.target.closest?.('.elagili-packaging-info')) return;

    const input = label.querySelector('input[type="radio"][name="attributes[Packaging preference]"]');
    if (!input || input.disabled) return;

    if (event.type === 'touchend') event.preventDefault();

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  document.addEventListener('click', selectPackagingRow, true);
  document.addEventListener('touchend', selectPackagingRow, { passive: false, capture: true });
}
